import { useEffect, useState } from 'react';
import CrudTable from '../../components/CrudTable';
import { db } from '../../lib/supabase';

// QT#4: hàng cần đẩy sale.
export default function SalePushAdmin() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    db.list('products', { orderBy: 'name', ascending: true }).then(({ data }) => setProducts(data || []));
  }, []);

  const productOpts = products.map((p) => ({ value: p.id, label: `${p.name} (tồn ${p.stock_quantity})` }));

  return (
    <CrudTable
      title="📉 Hàng cần đẩy sale"
      table="sale_push"
      defaults={{ status: 'active' }}
      columns={[
        { key: 'product_id', label: 'Sản phẩm', type: 'select', required: true, options: productOpts },
        { key: 'reason', label: 'Lý do đẩy', type: 'textarea' },
        { key: 'target_quantity', label: 'Mục tiêu bán (SL)', type: 'number' },
        { key: 'deadline', label: 'Hạn chót', type: 'date' },
        { key: 'status', label: 'Trạng thái', type: 'select', options: [
            { value: 'active', label: '🔥 Đang đẩy' },
            { value: 'done', label: '✅ Hoàn thành' },
            { value: 'cancelled', label: '✖ Huỷ' },
          ] },
      ]}
      emptyText="Chưa có mặt hàng nào trong danh sách đẩy sale."
    />
  );
}
